export enum OrderStatus {
    Opened = "opened",
    Closed = "closed",
    Canceled = "canceled",
}
